import React from "react";
import { useNavigate } from "react-router-dom";
import { Radio, HandHeart, Users, Target, Sparkles, ArrowRight, Presentation } from "lucide-react";
import MarketingLayout from "@/components/MarketingLayout";

function Section({ icon: Icon, title, children }) {
  return (
    <div className="ss-card" style={{ padding: 24, marginTop: 16 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
        <span style={{ width: 38, height: 38, borderRadius: 10, background: "var(--brand)", color: "#fff", display: "grid", placeItems: "center", flexShrink: 0 }}>
          <Icon size={19} />
        </span>
        <h2 style={{ fontSize: 20, fontWeight: 800 }}>{title}</h2>
      </div>
      <div style={{ color: "var(--muted)", fontSize: 15, lineHeight: 1.7 }}>{children}</div>
    </div>
  );
}

export default function About() {
  const navigate = useNavigate();
  return (
    <MarketingLayout>
      <div className="fade-up" data-testid="about-page">
        {/* Hero */}
        <div className="ss-card" style={{ padding: 34, background: "var(--brand)", color: "#fff", position: "relative" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(255,255,255,.14)", borderRadius: 999, padding: "6px 14px", fontSize: 12, fontWeight: 700, letterSpacing: 1, textTransform: "uppercase" }}>
            <Sparkles size={14} style={{ color: "var(--gold)" }} /> Live shopping, community &amp; giving
          </div>
          <h1 style={{ fontSize: 34, fontWeight: 800, marginTop: 16, lineHeight: 1.2 }}>
            Where Live Shopping, Community &amp; Giving Come Together
          </h1>
          <p style={{ marginTop: 14, fontSize: 16, lineHeight: 1.7, color: "rgba(255,255,255,.9)", maxWidth: 640 }}>
            Souq Stream is a modern live-commerce platform designed to connect sellers and buyers through engaging,
            interactive live shopping experiences. Our goal is to make online shopping more personal, social, and
            exciting — sellers showcase products live while customers discover, interact, ask questions, and shop in real time.
          </p>
        </div>

        <Section icon={Radio} title="A platform built for sellers">
          Souq Stream is built to support entrepreneurs, small businesses, independent sellers, and growing brands by
          giving them a platform to showcase their products, connect directly with customers, build their communities,
          and grow their businesses through live commerce.
        </Section>

        <Section icon={HandHeart} title="Islamic Fundraising">
          Souq Stream also includes a dedicated fundraising feature that allows users and communities to raise funds for
          special Islamic causes and charitable initiatives. It's designed to help bring people together to support
          meaningful causes and make a positive impact through the power of community and technology.
        </Section>

        {/* Founder */}
        <div className="ss-card" style={{ padding: 24, marginTop: 16, display: "flex", gap: 20, alignItems: "center", flexWrap: "wrap" }}>
          <div style={{ width: 96, height: 96, borderRadius: 999, overflow: "hidden", border: "3px solid var(--gold)", flexShrink: 0 }} data-testid="founder-photo">
            <img src="https://customer-assets-m6fa6gv7.emergentagent.net/job_desktop-streaming-1/artifacts/ztnsizxf_file_00000000df2471fdafb86646f0303b7c.png" alt="Jafar Rizvi" style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "center top" }} />
          </div>
          <div style={{ flex: 1, minWidth: 240 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
              <Users size={18} style={{ color: "var(--brand)" }} />
              <h2 style={{ fontSize: 20, fontWeight: 800 }}>Our Founder</h2>
            </div>
            <div style={{ color: "var(--muted)", fontSize: 15, lineHeight: 1.7 }}>
              Souq Stream was founded and created by <strong style={{ color: "var(--text)" }}>Jafar Rizvi</strong>, who
              envisioned a platform that combines live streaming, e-commerce, community, and charitable giving in one place.
              Driven by a belief that commerce should also strengthen communities, Jafar set out to build a home where
              Muslim sellers and shoppers could connect authentically. Under his leadership, Souq Stream is growing into
              a trusted destination where buying, selling, and giving back go hand in hand.
            </div>
          </div>
        </div>

        <Section icon={Target} title="Our Mission">
          Our mission is to empower sellers, connect communities, and create meaningful opportunities for people to shop,
          sell, support causes, and make a difference.
        </Section>

        <div style={{ textAlign: "center", margin: "26px 0 6px" }}>
          <p style={{ fontSize: 18, fontWeight: 800, color: "var(--brand)" }}>
            Souq Stream — Where Live Shopping, Community &amp; Giving Come Together.
          </p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", marginTop: 16, flexWrap: "wrap" }}>
            <button className="ss-btn ss-btn-primary" onClick={() => navigate("/")} data-testid="about-explore">
              Explore live shows <ArrowRight size={16} />
            </button>
            <button className="ss-btn ss-btn-ghost" onClick={() => navigate("/pitch")} data-testid="about-pitch">
              <Presentation size={16} /> Investor pitch deck
            </button>
          </div>
        </div>
      </div>
    </MarketingLayout>
  );
}
